import $ from 'jquery'


/* Block visibility observer
********************************************/

const blocks = document.querySelectorAll( '.block' );

const blockObserver = new IntersectionObserver(
	entries => {
	    entries.forEach( entry => {
	        if( entry.isIntersecting ) {
				entry.target.classList.toggle( 'is-visible' );
				entry.target.classList.add( 'is-seen' );
	        };
	    });
	},
	{
		//threshold: 0,
		//rootMargin: '100px',
	}
);

blocks.forEach( block => {
	blockObserver.observe(block);
});



/* Body width observer
********************************************/

const bodies = document.querySelectorAll('body');

const bodyObserver = new ResizeObserver(entries => {
	for (let entry of entries) {
		const vw = Math.floor(entry.contentRect.width) / 100;
		document.documentElement.style.setProperty('--vw', `${vw}px`);
	}
});

bodies.forEach(body => {
	bodyObserver.observe(body);
});
